import _ClosingSvg from '@src/assets/closing.svg?react';
import _DashboardSvg from '@src/assets/dashboard.svg?react';
import _LogoWhiteSvg from '@src/assets/logo_white.svg?react';
import _LogoSvg from '@src/assets/logo.svg?react';
import _ReportingSvg from '@src/assets/reporting.svg?react';
import _UserListSvg from '@src/assets/user_list.svg?react';
import _UserSvg from '@src/assets/user.svg?react';
import _UsersSvg from '@src/assets/users.svg?react';

import csi from './createSvgIcon';

export const Logo = csi('Logo', _LogoSvg, { viewBox: '0 0 283.54 147.28' });
export const LogoWhite = csi('LogoWhite', _LogoWhiteSvg, { viewBox: '0 0 84 44' });
export const ClosingIcon = csi('', _ClosingSvg, {});
export const DashboardIcon = csi('', _DashboardSvg, {viewBox: '0 0 17 17'});
export const ReportingIcon = csi('', _ReportingSvg, {});
export const UserIcon = csi('', _UserSvg, {});
export const UserListIcon = csi('', _UserListSvg, {});
export const UsersIcon = csi('', _UsersSvg, {});
